import React from 'react';
import PropTypes from 'prop-types';
import { TextArea } from "../Inputs";

export default class AltText extends React.Component
{
    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };

    render()
    {
        return <>
            <TextArea
                autoresize
                className='w-full resize-none'
                value={this.props.value}
                onChange={e => this.props.onChange(e.target.value)}
                onBlur={this.props.onBlur}
                placeholder='Describe your image.'
            />
        </>;
    }
}
